import {Box} from "@mui/material";
import {CustomAutoCompleteMenuOptionStyle} from "./Styles";
import CustomTooltip from "./CustomTooltip";
import React from "react";
import {POSITION_MODEL} from "../Helpers/PositionModel";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * Renders a styled menu option typically used within an autocomplete dropdown list.
 *
 * @param {Object} props - Component properties.
 * @param {string} props.label - The main text label to display.
 * @param {Function} [props.onClick] - Callback function triggered when the option is clicked.
 * @param {Function} [props.subSection] - Optional function that returns additional JSX to display under the label.
 * @param {React.ElementType} [props.Icon] - Optional icon component to display on the right side.
 *
 *
 */
const CustomAutoCompleteMenuOption= ({label, onClick, subSection, Icon, positionIconOptions = POSITION_MODEL.RIGHT}) => {


    return (
        <Box sx={CustomAutoCompleteMenuOptionStyle} onClick={onClick}>
            <div className={`${Icon && positionIconOptions === POSITION_MODEL.LEFT ? 'col-12': 'col-11'} p-0`} >
                <div className={"row"}>
                    <CustomTooltip
                        text={label}
                        classes={`fs-14px ibl-font-w-600 font-color-general-950 text-ellipsis-1-row p-0`}
                        showIfTruncated={true}
                        icon={Icon && positionIconOptions === POSITION_MODEL.LEFT && <Icon sx={CustomAutoCompleteMenuOptionStyle.icon} className={"pr-2 w-32px h-32px"}/>}
                    />
                </div>
                {
                    subSection &&
                    <div className={"row"}>
                        {subSection({divider:true})}
                    </div>
                }
            </div>
            {Icon && positionIconOptions === POSITION_MODEL.RIGHT &&  <div className={"col-1 p-0 d-flex justify-content-end"}><Icon sx={CustomAutoCompleteMenuOptionStyle.icon}/></div>}
        </Box>
    );
};

export default CustomAutoCompleteMenuOption
